<template>
  <div>
    <b-container>
      <div class="mt-4 mb-2 row d-flex justify-content-between justify-content-between">
        <div class="col-8">
          <back-arrow :bilan-type="bilanType"
                      :params="{operationId: this.operationId, operationType: this.operationType}"
                      :sub-title-ope="this.operationName"
                      :title="$t('ScheduleEdit')"
                      route-back="ScheduleShow"/>
        </div>
        <div class="col-4 justify-content-end d-flex">
        </div>


      </div>

      <b-card>
        <div class="col">
          <b-nav class="multi-tabs-field-navbar">
            <b-nav-item v-for="(lot, index) in operationLotsFiltered" :key="index + '-nav-key'"
                        :class="{ 'link-active': currentSection === index }"
                        class="multi-tabs-field-navbar-item"
                        @click.prevent="currentSection = index">
              {{ $t('OperationLot') + ' ' }}
              <span v-if="lot.lotCoPro.value">{{ lot.lotCoPro.value }} - </span>
              <span v-else>{{ (index + 1) }} - </span>
              <span v-if="lot.name.value">{{ lot.name.value }}</span>
            </b-nav-item>
          </b-nav>
        </div>
        <div class="mt-2">
          <div
            v-if="needSchedule && operationType && ((operationType ==='VIR' && operationLotComputed.isLotVir.value) || (operationType ==='VEFA'))"
            class="row mx-2">
            <b-form v-unsave-detector class="col no-gutters mx-0 my-0" @submit.stop.prevent="onSubmit">
              <schedule-vir-vefa :amount-vente="operationLotComputed.prixVenteTTC.value"
                                 :initial-schedule="this.operationLotComputed.schedule && this.operationLotComputed.schedule.value ? this.operationLotComputed.schedule.value : templateSchedule"
                                 :need-amount-preview="true"
                                 @schedule-changed="scheduleChanged"></schedule-vir-vefa>
              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import api from "../../../services/api"
import backArrow from "../../../components/b122/BackArrow";
import ScheduleVirVefa from "../components/ScheduleVirVefa";

export default {
  name: "ScheduleEdit",

  components: {
    backArrow,
    ScheduleVirVefa
  },

  props: {
    operationId: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      operationLots: [],
      bilanType: null,
      operationName: null,
      currentSection: 0,
      templateSchedule: null,
      operationType: null
    }
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    operationLotsFiltered() {
      if (this.operationType === 'DEFAULT') return []
      else if (this.operationType === 'VIR') return this.operationLots.filter(lot => lot.isLotVir.value)
      return this.operationLots
    },
    operationLotComputed() {
      return this.operationLotsFiltered[this.currentSection]
    },
    needSchedule() {
      return this.operationType && this.operationType !== 'DEFAULT'
    },
  },

  methods: {
    async fetchData() {
      await this.getOperationLots()
      if (this.operationId) {
        await this.getOperation()
      }
    },

    scheduleChanged(schedule, isValid) {
      this.operationLotComputed.schedule.value = schedule
      this.operationLotComputed.schedule.invalidFeedback = null
      this.operationLotComputed.schedule.state = isValid
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
            this.templateSchedule = response.data.schedule
            this.operationType = response.data.operationType
          })
      }
    },

    async onSubmit() {
      try {
        const result = await this.createOrUpdateOperationLots();
        if (!result) {
          return;
        }


        await this.$router.push({
          name: 'ScheduleShow',
          params: {operationId: this.operationId, operationType: this.operationType}
        });

        await this.generateMonthlyCharges();
      } catch (error) {
        console.error('Failed to create or update operation lots:', error);
      }
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async createOrUpdateOperationLots() {
      let index = 0
      let realIndexArray = 0
      let success = true;
      index = 1
      for (const operationLot of this.operationLots) {
        let data = new FormData()

        if (operationLot.schedule.value != null) {
          data.append('schedule', JSON.stringify(operationLot.schedule.value))
        }
        if (operationLot.schedule.state === false) {
          operationLot.schedule.invalidFeedback = this.$i18n.t('InvalidSchedule')
          operationLot.schedule.state = false
          this.currentSection = realIndexArray
          this.$forceUpdate()
          return false
        } else {
          operationLot.schedule.invalidFeedback = null
          operationLot.schedule.state = true
        }

        index++

        let url = '/operationLot/updateSchedule/' + operationLot.id

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
            realIndexArray++
          })
          .catch((error) => {
            success = false
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: this.currentSectionId,
                  message: error.response.data.message
                }
              })
            } else if (error.response.status === 403) {
              this.currentSection = realIndexArray
              const invalidField = error.response.data.invalidField
              this.operationLots[realIndexArray][invalidField]['state'] = false
              this.operationLots[realIndexArray][invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            }
          })

      }
      return success;
    },

    formatDateFR(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      const jour = String(date.getDate()).padStart(2, '0');
      const mois = String(date.getMonth() + 1).padStart(2, '0');
      const annee = date.getFullYear();
      return `${jour}/${mois}/${annee}`;
    },

    formatMoneyEUR(amount) {
      if (amount == null) return "";
      return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(amount / 100);
    },

    async getOperationLots() {
      if (this.operationId) {
        await this.getOperationLotsFromOperation()
      }
    },

    async getOperationLotsFromOperation() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          response.data.forEach(lot => {

            let debutConstruction = null
            if (lot.debutConstruction) {
              debutConstruction = new Date(lot.debutConstruction).toLocaleDateString().split("/").reverse().join("-")
            } else {
              if (this.operationInitialStartDate && this.operationInitialStartDate !== 0) {
                debutConstruction = new Date(this.operationInitialStartDate).toLocaleDateString().split("/").reverse().join("-")
              }
            }

            let finConstruction = null
            if (lot.finConstruction) {
              finConstruction = new Date(lot.finConstruction).toLocaleDateString().split("/").reverse().join("-")
            } else {
              if (this.operationInitialEndDate && this.operationInitialEndDate !== 0) {
                finConstruction = new Date(this.operationInitialEndDate).toLocaleDateString().split("/").reverse().join("-")
              }
            }

            let sspVente = null
            if (lot.sspVente) {
              sspVente = new Date(lot.sspVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let acteVente = null
            if (lot.acteVente) {
              acteVente = new Date(lot.acteVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let pretAcheteur = null
            if (lot.pretAcheteur) {
              pretAcheteur = new Date(lot.pretAcheteur).toLocaleDateString().split("/").reverse().join("-")
            }

            let depotPermis = null
            if (lot.depotPermis) {
              depotPermis = new Date(lot.depotPermis).toLocaleDateString().split("/").reverse().join("-")
            }

            let accordPermis = null
            if (lot.accordPermis) {
              accordPermis = new Date(lot.accordPermis).toLocaleDateString().split("/").reverse().join("-")
            }


            this.operationLots.push({
              id: lot.id,
              name: {state: null, invalidFeedback: null, value: lot.name},
              prixParM2: {state: null, invalidFeedback: null, value: lot.prixParM2},
              prixVenteTTC: {state: null, invalidFeedback: null, value: lot.prixVenteTTC},
              typeLot: {state: null, invalidFeedback: null, value: lot.typeLot.value},
              surface: {state: null, invalidFeedback: null, value: lot.surface},
              etage: {state: null, invalidFeedback: null, value: lot.etage.value},
              lotCoPro: {state: null, invalidFeedback: null, value: lot.lotCoPro},
              comment: {state: null, invalidFeedback: null, value: lot.comment},
              percentageTreso: {state: null, invalidFeedback: null, value: lot.percentageTreso},
              isLotVir: {state: null, invalidFeedback: null, value: lot.isLotVir},
              debutConstruction: {
                state: null,
                invalidFeedback: null,
                value: debutConstruction
              },
              finConstruction: {
                state: null,
                invalidFeedback: null,
                value: finConstruction
              },
              acteVente: {
                state: null,
                invalidFeedback: null,
                value: acteVente
              },
              sspVente: {
                state: null,
                invalidFeedback: null,
                value: sspVente
              },
              realDate: {state: null, invalidFeedback: null, value: lot.realDate},
              realDateSSP: {state: null, invalidFeedback: null, value: lot.realDateSSP},
              pretAcheteur: {state: null, invalidFeedback: null, value: pretAcheteur},
              depotPermis: {state: null, invalidFeedback: null, value: depotPermis},
              accordPermis: {state: null, invalidFeedback: null, value: accordPermis},
              isLoue: {state: null, invalidFeedback: null, value: lot.isLoue},
              dureeBail: {state: null, invalidFeedback: null, value: lot.dureeBail},
              loyersPercus: {state: null, invalidFeedback: null, value: lot.loyersPercus},
              tauxTVA: {state: null, invalidFeedback: null, value: lot.tauxTVA},
              schedule: {state: null, invalidFeedback: null, value: lot.schedule},
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationSchedule/ScheduleEdit.vue